<template>
  <div class="dm-filter" :class="{ open: openFilters }" v-if="showFilters">
    <slot
      name="filterButton"
      :toggleFilters="toggleFilters"
      :translations="translations"
    >
      <div class="dm-filter__button" @click="toggleFilters">
        <i class="far fa-angle-down"></i>
        <span>{{ translations.FilterTitle }}</span>
      </div>
    </slot>
    <div class="dm-filter__body">
      <div class="dm-filter__filter">
        <slot
          name="filterItem"
          :allCategories="allCategories"
          :changeFilter="changeFilter"
          :selectedFilters="selectedFilters"
          :getMarker="getMarker"
          :openTooltip="openTooltip"
          :toggleTooltip="toggleTooltip"
        >
          <div
            class="dm-filter__item"
            v-for="category in allCategories"
            :key="category.Id"
          >
            <div class="custom-control custom-checkbox flex-grow">
              <input
                type="checkbox"
                class="custom-control-input"
                :id="'filter' + category.CodeName"
                :value="category.CodeName"
                @change="changeFilter(category.CodeName)"
              />
              <label
                class="custom-control-label"
                :for="'filter' + category.CodeName"
              >
                <img
                  :src="getMarker(category.CodeName)"
                  width="18"
                  height="22"
                />
                <span>{{ category.DisplayName }}</span>
              </label>
            </div>
            <div
              class="dm-tooltip"
              v-if="category.Tooltip !== null"
              :class="{ open: openTooltip }"
            >
              <div class="dm-tooltip__button" @click="toggleTooltip()">
                <i class="far fa-info-circle"></i>
              </div>
              <div class="dm-tooltip__body">
                {{ category.Tooltip }}
              </div>
            </div>
          </div>
        </slot>
      </div>
      <slot name="filterPostText" :translations="translations">
        <div class="dm-filter__post" v-if="translations.FilterPostText != null">
          {{ translations.FilterPostText }}
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentFilters',
  props: {
    allCategories: Array,
    selectedCategories: Array,
    assetsFolder: String,
    translations: Object,
    showFilters: Boolean,
  },
  data() {
    return {
      openFilters: true,
      selectedFilters: [],
      openTooltip: false,
      localSelectedCategories: [],
    }
  },
  methods: {
    toggleFilters() {
      this.openFilters = !this.openFilters
    },
    getMarker(name) {
      return this.assetsFolder + '/marker_' + name + '.png'
    },
    changeFilter(d) {
      const toggle = (array, item) =>
        array.includes(item)
          ? array.filter(x => x !== item)
          : [...array, item];
      this.localSelectedCategories = toggle(this.localSelectedCategories, d)
      this.$emit('update:selectedCategories', this.localSelectedCategories)
    },
    toggleTooltip() {
      this.openTooltip = !this.openTooltip
    },
  },
}
</script>

<style lang="scss">
.flex-grow {
  flex-grow: 1;
}

.dm-filter {
  flex: 0 0 auto;
  padding: 0 30px 30px 30px;

  &__button {
    display: flex;
    align-items: center;
    cursor: pointer;

    i {
      flex: 0 0 auto;
    }

    i + span {
      padding-left: 10px;
    }
  }

  &__body {
    display: none;
    padding-top: 20px;
  }

  &__item {
    display: flex;
    align-items: center;
  }

  &__icon {
    background: #000;
    width: 18px;
    height: 23px;
    display: inline-block;
  }

  &.open {
    .dm-filter__button {
      i {
        transform: rotate(180deg);
      }
    }

    .dm-filter__body {
      display: block;
    }
  }
}

.dm-tooltip {
  position: relative;

  &__button {
    cursor: pointer;

    i {
      flex: 0 0 auto;
    }
  }

  &__body {
    display: none;
    position: absolute;
    bottom: 100%;
    margin-bottom: 10px;
    width: 320px;
    left: 50%;
    margin-left: -160px;
    background: #fff;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.25);
    padding: 20px;
    z-index: 10;

    &:before {
      content: '\A';
      border-style: solid;
      border-width: 10px 10px 0 10px;
      border-color: rgba(0, 0, 0, 0.18) transparent transparent transparent;
      position: absolute;
      left: 50%;
      margin-left: -10px;
      bottom: -10px;
      z-index: 20;
    }

    &:after {
      content: '\A';
      border-style: solid;
      border-width: 10px 10px 0 10px;
      border-color: #fff transparent transparent transparent;
      position: absolute;
      left: 50%;
      margin-left: -10px;
      bottom: -9px;
      z-index: 30;
    }
  }

  &:hover,
  &:focus {
    .dm-tooltip__body {
      display: block;
    }
  }
}
</style>
